import { MACHINEUSER_KEY } from '../../../../../auth';

/**
 * Generates the 'machineuser' Basic auth credentials for use with endpoint authorization.
 *
 * @returns {string}
 */
export function getBasicAuthForSportradar() {
	const credentials = `machineuser:${ MACHINEUSER_KEY }`;
	return btoa( credentials );
}
